import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

// ACTIONS
import {
	consultaInteracoesAtendimentoSuccess,
	consultaInteracoesAtendimentoFailure,
} from './actions';

function* consultaInteracoesAtendimentoRequest(request: ReducerAction) {
	const { payload } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`interacoes/${CHANNEL}/atendimentos/consulta-interacoes`,
		payload,
	);

	if (response.status === 200) {
		yield put(consultaInteracoesAtendimentoSuccess(response));
	} else {
		yield put(consultaInteracoesAtendimentoFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_INTERACOES_ATENDIMENTO_REQUEST,
		consultaInteracoesAtendimentoRequest,
	),
]);
